import { ApplicationAccessType, CommunicationType } from 'domains/content/types';
import { WhatsAppContentStateTypes } from './whatsAppTypes';

export enum actionTypes {
    SET_NAME = 'SET_NAME',
    SET_BODY_TEXT = 'SET_BODY_TEXT', // Updates BODY component text
    SET_APPLICATIONS_ACCESS = 'SET_APPLICATIONS_ACCESS',
    SET_COMMUNICATION_TYPE = 'SET_COMMUNICATION_TYPE',
    SET_WHATSAPP_STATE = 'SET_WHATSAPP_STATE', // Set entire state from API data
}

// Actions
export const setName = (name: string) => ({ type: actionTypes.SET_NAME, name });

export const setBodyText = (text: string) => ({ type: actionTypes.SET_BODY_TEXT, text });

export const setApplicationsAccess = (applicationsAccess: ApplicationAccessType[]) => ({
    type: actionTypes.SET_APPLICATIONS_ACCESS,
    applicationsAccess,
});

export const setCommunicationType = (communicationType: CommunicationType) => ({
    type: actionTypes.SET_COMMUNICATION_TYPE,
    communicationType,
});

export const setWhatsAppState = (whatsAppState: WhatsAppContentStateTypes) => ({
    type: actionTypes.SET_WHATSAPP_STATE,
    whatsAppState,
});
